import { Layout } from '@glu/core';
import ManageColumnsMenu from './manageColumnsMenu';

import template from './manageColumns.hbs';

export default Layout.extend({
  template,
  className: 'grid-manage-columns',

  regions: {
    manageColumnsMenu: '#region-manage-columns-menu'
  },

  ui: {
    $menuTrigger: '.grid-manage-column-menu-trigger'
  },

  events: {
    'click @ui.$menuTrigger': 'toggleManageColumnMenu'
  },

  initialize() {
    this.grid = this.options.grid;
    this.listenTo(this.grid, {
      'grid:columnResizeComplete': this.updateHeight,
      'grid:contentRendered': this.updateHeight
    });
  },

  toggleManageColumnMenu(e) {
    e.preventDefault();

    if (!this.manageColumnsLayout) {
      this.manageColumnsLayout = new ManageColumnsMenu({
        collection: this.options.columns,
        filterProcessor: this.options.filterProcessor,
        grid: this.grid
      });

      this.listenTo(this.manageColumnsLayout, 'close', this.removeManageColumnsLayout);
      return this.manageColumnsMenu.show(this.manageColumnsLayout);
    }

    this.removeManageColumnsLayout();
  },

  removeManageColumnsLayout() {
    if (!this.manageColumnsLayout) {
      return;
    }
    this.manageColumnsLayout.close();
    this.manageColumnsLayout = null;
  },

  updateHeight() {
    const $thead = this.grid.$('thead');

    if (!$thead.length) {
      return false;
    }

    const height = window.parseInt($thead[0].getBoundingClientRect().height);
    this.ui.$menuTrigger.height(height);
  }
});
